import styled from 'styled-components';

export const UiCheckboxGroup = styled.div`
	display: block;
`;
